export const SUBSCRIBE_EMAIL_CONTAINER = 'js-home-email-subscription-container';

export const HERO_IMAGE = 'js-home-hero-image';

export const PURCHASE_SECTION = 'purchase-section';
